import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { HgSpendCategory } from "../../../../types/taxonomy";

const WorkspaceSpendCategoryTooltipList: React.FC<{
  categories: HgSpendCategory[];
  weights: { [key: string]: number };
}> = ({ categories, weights }) => {
  return (
    <List>
      {categories.map((category, index) => (
        <ListItem key={index}>
          <Box width={1} display="flex" justifyContent="space-between">
            <Typography variant="body2" color="inherit">
              {category.name}
            </Typography>
            <Typography variant="body2" color="inherit">
              {weights[category.id]} %
            </Typography>
          </Box>
        </ListItem>
      ))}
    </List>
  );
};

export default WorkspaceSpendCategoryTooltipList;
